import { FC, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { Jobs } from "app/pages/individual/jobs/jobs";
import { useAuth } from "app/pages/module/auth";
import CleanerProfileNew from "app/pages/cleaner/CleanerProfileNew";
import { AppliedWorkOrder } from "app/pages/jobs/Myjobs/AppliedWorkOrder";
import { LocationManage } from "app/pages/individual/basicdetails/LocationManage";
import CleanerProfile from "app/pages/cleaner/CleanerProfile";
import { JobPostNew } from "app/pages/individual/jobs/JobPostNew";
import { AccountSetting } from "app/pages/individual/AccountSetting/AccountSetting";
import { JobPostDetails } from "app/pages/individual/jobs/JobPostDetails";
import { CleanerProfiles } from "app/pages/individual/jobs/CleanerProfiles";
import { Confirm } from "app/pages/individual/jobs/Confirm";
import { ConfirmAndBook } from "app/pages/individual/jobs/ConfirmAndBook/ConfirmAndBook";
import { SavedWorkOrder } from "app/pages/jobs/workorder/SavedWorkOrder";
import { CompanyRoutes } from "./component/CompanyRoutes";
import { SupervisorRoutes } from "./component/SupervisorRoutes";
import { ReviewWorkOrder } from "app/pages/jobs/Myjobs/ReviewWorkOrder";
import { IndividualCleanerProfile } from "app/pages/individual/jobs/IndividualCleanerProfile";
import { Calendar } from "app/pages/jobs/Myjobs/calendar/Calendar";
import { ConfirmAndChat } from "app/pages/individual/jobs/ConfirmAndBook/ConfirmAndChat";
import { IndividualChat } from "app/pages/jobs/Individual-jobs/IndividualChat";
import { CleanerWallet } from "app/pages/cleaner/CleanerWallet";
import { Reward } from "app/pages/cleaner/reward/Reward";
import { MyJobs } from "app/pages/jobs/Myjobs/MyJobs";
import { MyJobDetails } from "app/pages/jobs/Myjobs/MyJobDetails";
import { PendingJobs } from "app/pages/jobs/Myjobs/PendingJobs";
import { WorkOrderList } from "app/pages/jobs/workorder/WorkOrderList";
import { WorkOrderDetails } from "app/pages/jobs/workorder/WorkOrderDetails";
import { Message } from "app/pages/cleaner/message/Messages";
import SavedJobs from "app/pages/jobs/SavedJobs";
import AppliedJobs from "app/pages/jobs/AppliedJobs";
import { CorporateRoutes } from "./component/CorporateRoutes";
import { IndividualMyTransactions } from "app/pages/individual/transactions/MyTransactions";
import { CleanerMyTransactions } from "app/pages/cleaner/transactions/MyTransactions";
import { CheckerStatus } from "app/pages/cleaner/checkr/CheckerStatus";
import { TargetProfileOnboarding } from "app/pages/module/auth/TargetProfileOnboarding";

type WithChildren = {
  children: any;
};

const PrivateRoutes = () => {
  // const UploadModule = lazy(() => import('../modules/profile/ProfilePage'))
  const { isAuthenticate, isAuthReady, logout, userType } = useAuth();
  //  if(isLoading){
  //   return <LayoutSplashScreen />
  //  }
  return (
    <Routes>
      <Route>
        {userType === "corporate" && (
          <>
            {CorporateRoutes.map((data, index) => (
              <Route key={index} path={data.path} element={<data.element />}>
                {data.children?.map((child, i) => (
                  <Route
                    key={i}
                    path={child.path}
                    element={<child.element />}
                  />
                ))}
              </Route>
            ))}
            <Route
              path="/*"
              element={<Navigate to="/corporate/requirement-listing" />}
            />
          </>
        )}

        {userType === "company" && (
          <>
            {CompanyRoutes?.map((data, index) => (
              <Route key={index} path={data.path} element={<data.element />} />
            ))}
            <Route path="/*" element={<Navigate to="/jobs-listing" />} />
          </>
        )}

        {userType === "cleaner" && (
          <>
            <Route
              path="/cleaner/onboarding"
              element={<TargetProfileOnboarding targetType="cleaner" />}
            />
            <Route path="/cleaner-profile" element={<CleanerProfile />} />
            <Route path="/cleaner/message" element={<Message />} />
            <Route
              path="/cleaner-profile-page"
              element={<CleanerProfileNew />}
            />
            <Route
              path="/cleaner/my-transactions"
              element={<CleanerMyTransactions />}
            />
            <Route
              path="/cleaner/applied-work-order"
              element={<AppliedWorkOrder />}
            />
            <Route path="/saved-work-order" element={<SavedWorkOrder />} />
            <Route
              path="/review-work-order/:id"
              element={<ReviewWorkOrder />}
            />
            <Route path="/*" element={<Navigate to="/cleaner-jobs" />} />
            <Route path="/cleaner/work-order/calendar" element={<Calendar />} />
            <Route
              path="/cleaner/individual/chat/:jobId"
              element={<IndividualChat />}
            />
            <Route path="/cleaner/wallet" element={<CleanerWallet />}></Route>
            <Route
              path="/cleaner/wallet/:tab"
              element={<CleanerWallet />}
            ></Route>
            <Route path="/cleaner/work-order" element={<WorkOrderList />} />
            <Route
              path="/cleaner/work-order-details/:id"
              element={<WorkOrderDetails />}
            />
            <Route path="/my-jobs" element={<MyJobs />} />
            <Route path="/my-job-details/:id" element={<MyJobDetails />} />
            <Route path="/pending-jobs" element={<PendingJobs />} />
            <Route path="/cleaner/reward" element={<Reward />}></Route>
            <Route path="/saved-jobs" element={<SavedJobs />} />
            <Route path="/applied-jobs" element={<AppliedJobs />} />
            <Route path="/checker/status" element={<CheckerStatus />} />
          </>
        )}
        {userType === "supervisor" && (
          <Route path="/*" element={<SupervisorRoutes />} />
        )}

        {userType === "individual" && (
          <>
            <Route
              path="/individual/onboarding"
              element={<TargetProfileOnboarding targetType="individual" />}
            />
            <>
              <Route path="/individual/jobs" element={<Jobs />} />
              <Route
                path="/individual/my-transactions"
                element={<IndividualMyTransactions />}
              />
              <Route path="/individual/location" element={<LocationManage />} />
              <Route
                path="/individual/cleaner-profile/:from/:to"
                element={<CleanerProfile />}
              />
              <Route path="/individual/job-post-new" element={<JobPostNew />} />
              <Route
                path="/individual/job-post-details"
                element={<JobPostDetails />}
              />
              <Route
                path="/individual/job-post-details/:title"
                element={<JobPostDetails />}
              />
              <Route
                path="/individual/job-post-details/:title/:id"
                element={<JobPostDetails />}
              />

              <Route path="/individual/Account" element={<AccountSetting />} />
              <Route
                path="/individual/cleaner-profiles/:from/:to/:jobid"
                element={<CleanerProfiles />}
              />
              <Route path="/individual/confirm/:id" element={<Confirm />} />
              <Route
                path="/individual/cleaner-profile-details/:id/:jobid/:from/:to"
                element={<IndividualCleanerProfile />}
              />
              <Route
                path="/individual/confirm-and-book/:id"
                element={<ConfirmAndBook />}
              />
              <Route
                path="/individual/confirm-and-chat/:id"
                element={<ConfirmAndChat />}
              />
              <Route path="/*" element={<Navigate to="/individual/jobs" />} />
            </>
          </>
        )}
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  TopBarProgress.config({
    barColors: {
      "0": "#000",
    },
    barThickness: 4,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
